var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVerifier(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3585",
    "data-name": "Rectangle 3585",
    width: 21,
    height: 20,
    transform: "translate(-5 -2)",
    fill: "#1a49a3"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_42934",
    "data-name": "Group 42934",
    transform: "translate(-16 -131)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_8",
    "data-name": "Mask Group 8",
    transform: "translate(21 133)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1",
    transform: "translate(-4.133 0.41)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40674",
    "data-name": "Path 40674",
    d: "M10,6.177a3.739,3.739,0,0,0,1.156-2.892.263.263,0,0,1,0-.058c.291-1.614.906-2.637,1.829-3.039A3.06,3.06,0,0,1,15.609.5a3.061,3.061,0,0,1,1.576,2.114c.112,1-.466,2.044-1.718,3.1a.245.245,0,0,1-.048.033c-.02.01-1.784.944-1.927,2.447Z",
    transform: "translate(1.751 -0.001)",
    fill: "#1a49a3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40675",
    "data-name": "Path 40675",
    d: "M15.546,11.124a.26.26,0,0,1-.13-.035L8.6,7.153A5.776,5.776,0,0,0,8.63,4.1l7.189,4.151a1.329,1.329,0,0,1,.486,1.814l-.534.926a.26.26,0,0,1-.157.121A.255.255,0,0,1,15.546,11.124Z",
    transform: "translate(1.214 1.569)",
    fill: "#1a49a3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40676",
    "data-name": "Path 40676",
    d: "M13.98,10.688a.258.258,0,0,1-.13-.035L8.224,7.405a5.784,5.784,0,0,0,.347-.734l5.908,3.411-.275.476A.26.26,0,0,1,13.98,10.688Z",
    transform: "translate(1.071 3.006)",
    fill: "#1a49a3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40677",
    "data-name": "Path 40677",
    d: "M8.881,11.088a.26.26,0,0,1-.251-.327L9.049,9.2a.259.259,0,0,1,.5.134L9.131,10.9a.259.259,0,0,1-.25.192Z",
    transform: "translate(1.223 3.445)",
    fill: "#1a49a3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40678",
    "data-name": "Path 40678",
    d: "M10.464,11.737a.259.259,0,0,1-.183-.442l1.143-1.143a.259.259,0,0,1,.366.367l-1.143,1.143a.258.258,0,0,1-.183.076Z",
    transform: "translate(1.829 3.853)",
    fill: "#1a49a3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40679",
    "data-name": "Path 40679",
    d: "M7.243,11.217a.259.259,0,0,1-.25-.192L6.574,9.464a.259.259,0,1,1,.5-.134l.418,1.561a.26.26,0,0,1-.251.327Z",
    transform: "translate(0.436 3.494)",
    fill: "#1a49a3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_37826",
    "data-name": "Group 37826",
    transform: "translate(0 2.765)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40681",
    "data-name": "Path 40681",
    d: "M5.138,10.058A4.344,4.344,0,1,1,9.483,5.714,4.349,4.349,0,0,1,5.138,10.058Zm0-1.169A3.176,3.176,0,1,1,8.314,5.714,3.179,3.179,0,0,1,5.138,8.889Z",
    transform: "translate(-0.794 -1.369)",
    fill: "#1a49a3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40682",
    "data-name": "Path 40682",
    d: "M4.245,6.576a.215.215,0,0,1-.152-.063l-.952-.952a.215.215,0,1,1,.3-.3l.8.8L6.17,4.132a.215.215,0,0,1,.3.3L4.4,6.513a.214.214,0,0,1-.152.063Z",
    transform: "translate(-0.463 -0.978)",
    fill: "#1a49a3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40672_-_Outline",
    "data-name": "Path 40672 - Outline",
    d: "M4.266,6.769a.386.386,0,0,1-.273-.113L3.041,5.7a.386.386,0,0,1,.546-.546l.679.679,1.8-1.8a.386.386,0,1,1,.546.547L4.539,6.656A.384.384,0,0,1,4.266,6.769ZM3.314,5.388a.042.042,0,0,0-.03.013.043.043,0,0,0,0,.061l.952.952a.043.043,0,0,0,.061,0L6.374,4.336a.042.042,0,0,0,.013-.031.042.042,0,0,0-.013-.03.043.043,0,0,0-.061,0L4.266,6.322,3.344,5.4A.042.042,0,0,0,3.314,5.388Z",
    transform: "translate(-0.485 -1)",
    fill: "#1a49a3"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifier);
export default __webpack_public_path__ + "static/media/verifier.8d24cddba40b28d8087cf1af1d5de707.svg";
export { ForwardRef as ReactComponent };